import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  children: ReactNode;
}

export function Chip({ active = false, children, className = "", ...props }: ChipProps) {
  return (
    <button
      type="button"
      className={[active ? "edlab-chip-active" : "edlab-chip", className].join(" ")}
      {...props}
    >
      {children}
    </button>
  );
}

interface ChipGroupProps {
  children: ReactNode;
  className?: string;
}

export function ChipGroup({ children, className = "" }: ChipGroupProps) {
  return <div className={["flex flex-wrap gap-[5px]", className].join(" ")}>{children}</div>;
}
